import React from 'react'
import Styled from 'styled-components'

const Container = Styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

const Plane = Styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
`

const Shape = Styled.div`
  width: 1.25rem;
  height: 1.25rem;
  background-color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.gray.shade100};
  box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.1);
  border-radius: ${props => `
    ${props.value > 1 ? props.value * 0.111 : 0}rem
  `};
  transition: 300ms;

  ${props => props.isActive && `
    border-color: ${props.theme.colors.white};
    background-color: ${props.theme.colors.white};
  `}
`

export default props => (
  <Container>
    <Plane
      value={props.value}
      isActive={props.isActive}
    >
      <Shape
        value={props.value}
        isActive={props.isActive}
      />
    </Plane>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/ThemeIconRoundness/index.js